import React, { useState } from 'react';
import ListView from "../components/List/ProgramList";
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { fetchPrograms } from "../store/ProgramSlice";
import debounce from 'lodash/debounce';

export default function Program() {
    const { t } = useTranslation();
    const [changeText, setChangeText] = useState(true);

    const dispatch = useDispatch<any>();
    const handleSearch = (query: string) => {
        dispatch(fetchPrograms({ search: query }));
    };
    const debouncedSearch = debounce(handleSearch, 300);
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setChangeText(e.target.value === '');
        const query = e.target.value;
        debouncedSearch(query);
    };

    return (
        <div className="flex-1 flex flex-col min-h-0">
            <h2 className="py-1 pb-3 sm:pb-4 text-xl sm:text-2xl font-gilroy font-semibold text-[#263238] shrink-0">
                {t("adminPrograms.title", "Programs")}
            </h2>
            <div className="bg-white flex-1 min-h-[380px] rounded-md overflow-hidden flex flex-col shadow-sm">
                <div className="flex flex-col sm:flex-row p-4 sm:p-6 pb-3 sm:pb-4 gap-3 sm:gap-4 shrink-0">
                    <form className="flex items-start w-full sm:w-auto sm:flex-1 max-w-md" onSubmit={(e) => e.preventDefault()}>
                        <div className="relative w-full">
                            <input
                                type="text"
                                placeholder=""
                                onChange={handleChange}
                                className="border border-gray-200 rounded-md py-2 w-full pl-10 pr-4 focus:outline-none placeholder-[#B0BEC5] bg-[#F5F7F8] text-sm"
                            />
                            {changeText && (
                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <img src='./images/Vector.png' className="w-4 h-4 mr-2" alt="search" />
                                    <span className='text-sm text-[#B0BEC5]'>{t("adminPrograms.search", "Search")}</span>
                                </div>
                            )}
                        </div>
                    </form>
                    <Link
                        to="add"
                        className="bg-[#B4804A] hover:bg-[#9d6f3e] transition-colors flex sm:ml-auto py-2.5 px-4 justify-center text-center items-center rounded-lg font-gilroy font-bold text-white text-sm whitespace-nowrap shadow-xs w-full sm:w-auto"
                    >
                        <img src='./images/plus.png' className="pr-2 w-5 h-5 object-contain" alt="btn" />
                        {t("adminPrograms.addNewProgram", "Add New Programs")}
                    </Link>
                </div>

                <div className="flex-1 overflow-hidden flex flex-col min-h-0">
                    <ListView />
                </div>
            </div>
        </div>
    );
}
